import styled from 'styled-components';
export const Container = styled.div`
  display: flex;
  height: 100%;
  width: 100%;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: #e8e8e8;
`

export const Preview = styled.div`
  display: flex;
  width: 100%;
  height: calc(100% - 30px);
  justify-content: center;
  align-items: center;
  .preview--pdf{
    max-width: 100%;
    max-height: 100%;
    overflow: hidden;
  }
  .preview--img{
    display: flex;
    width: 100%;
    height: 100%;
    background: #d5d5d5;
    border-radius: 9px;
    img{
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }
  .preview--video{
    display: flex;
    position: relative;
    width: 100%;
    height: 100%;
    background: #d5d5d5;
    border-radius: 9px;
    justify-content: center;
    align-items: center;
    video{
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
    .circle{
      position: absolute;
      display: flex;
      width: 50px;
      height: 50px;
      background-color: #0000009c;
      border-radius: 50%;
      justify-content: center;
      align-items: center;
      cursor: pointer;
    }
    .play-- {
      width: 0;
      height: 0;
      border-style: solid;
      opacity: 1;
      border-width: 0 10px 10px 10px;
      border-color: transparent transparent #ffffff transparent; 
      border-radius: 10px; 
      transform: rotate(90deg);
      cursor: pointer;
    }
  }
  .document {
    position: absolute;
    height: 100px;
    width: 70px;
    z-index: 1;
    background-color: #ffffff;
    border-radius: 8px;
    .triangle-chamfer {
      width: 0;
      height: 0;
      border-style: solid;
      border-width: 0 30px 30px 0;
      border-color: transparent #e8e8e8 transparent transparent;
      position: absolute;
      right: -3px;
      top: -3px;
      z-index: 20;
    }
    .triangle-corner {
      width: 0;
      height: 0;
      border-style: solid;
      border-width: 24px 0 0 24px;
      border-color: transparent transparent transparent #ffffff;
      position: absolute;
      right: 0;
      z-index: 2;
      box-shadow: -1px 1px 4px 0px rgba(0, 0, 0, 0.20);
      border-radius: 0 8px;
    }
    .icon{
      display: flex;
      width: 100%;
      height: 100%;
      justify-content: center;
      align-items: center;
    }
  }
`
export const Description = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  overflow: hidden;
  margin-top: 0.5rem;
  span{
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`